// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-codex-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  animation: codex-fade-in 0.2s ease;
}

@keyframes codex-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.help-codex-panel {
  background: rgba(18, 18, 18, 0.97);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 24px;
  max-width: 420px;
  width: 92%;
  max-height: 80vh;
  overflow-y: auto;
  animation: codex-scale-in 0.25s ease;
  backdrop-filter: blur(20px);
}

@keyframes codex-scale-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.help-codex-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.help-codex-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  flex: 1 1;
}

.help-codex-progress {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #ef4444;
  text-transform: uppercase;
}

.help-codex-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.help-codex-close:hover {
  color: #fff;
}

.help-codex-entries {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.help-codex-entry {
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
}

.help-codex-entry--locked {
  opacity: 0.45;
}

.help-codex-entry-title {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.help-codex-entry-body {
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.6);
}

.help-codex-entry--locked .help-codex-entry-title {
  color: rgba(255, 255, 255, 0.5);
}

.help-codex-entry--locked .help-codex-entry-body {
  font-style: italic;
  color: rgba(255, 255, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/HelpCodex/HelpCodex.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC","sourcesContent":[".help-codex-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  animation: codex-fade-in 0.2s ease;\n}\n\n@keyframes codex-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.help-codex-panel {\n  background: rgba(18, 18, 18, 0.97);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 420px;\n  width: 92%;\n  max-height: 80vh;\n  overflow-y: auto;\n  animation: codex-scale-in 0.25s ease;\n  backdrop-filter: blur(20px);\n}\n\n@keyframes codex-scale-in {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.help-codex-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.help-codex-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n  flex: 1;\n}\n\n.help-codex-progress {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  color: #ef4444;\n  text-transform: uppercase;\n}\n\n.help-codex-close {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n}\n\n.help-codex-close:hover {\n  color: #fff;\n}\n\n.help-codex-entries {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.help-codex-entry {\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n}\n\n.help-codex-entry--locked {\n  opacity: 0.45;\n}\n\n.help-codex-entry-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.help-codex-entry-body {\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.help-codex-entry--locked .help-codex-entry-title {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.help-codex-entry--locked .help-codex-entry-body {\n  font-style: italic;\n  color: rgba(255, 255, 255, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
